export default __webpack_public_path__ + "assets/images/426e40c89b4f470908800a6837bc39e7.jpg";